export default "__VITE_ASSET__2341a296__"